/**
 * Scroll-animatie voor Onze.
 *
 * Eén patroon voor de hele site, overgenomen van de referentie andsome.nl: een
 * element komt van 40px onder zijn plek en van doorzichtig naar vol, in 0.8s.
 * Elementen die in dezelfde rij binnenkomen krijgen een trapje van 80ms, zodat
 * een raster zich uitvouwt in plaats van in één klap te verschijnen.
 *
 * De opmaak staat in custom-brand.css onder [data-ob-reveal]; dit bestand doet
 * alleen de waarneming.
 */

(() => {
  const SELECTOR = '[data-ob-reveal]';

  // Respecteer de systeeminstelling. We zetten dan niets aan: de CSS toont
  // [data-ob-reveal] standaard al zichtbaar zodra deze klasse ontbreekt.
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  document.documentElement.classList.add('ob-reveal-enabled');

  /** Groepeert op verticale positie, zodat elementen naast elkaar samen oplopen. */
  const rowOf = (element) => Math.round(element.getBoundingClientRect().top / 100);

  const observer = new IntersectionObserver(
    (entries) => {
      const rows = new Map();

      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const row = rowOf(entry.target);
        const index = rows.get(row) ?? 0;
        rows.set(row, index + 1);

        entry.target.style.transitionDelay = `${Math.min(index, 5) * 80}ms`;
        entry.target.classList.add('ob-in-view');
        observer.unobserve(entry.target);
      }
    },
    // Iets voor de onderrand laten aanslaan, anders is de animatie al voorbij
    // tegen de tijd dat het element echt in beeld staat.
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  const observe = (root = document) => {
    for (const element of root.querySelectorAll(SELECTOR)) {
      if (element.dataset.obObserved) continue;
      element.dataset.obObserved = '';
      observer.observe(element);
    }
  };

  observe();

  // De theme editor voegt secties toe zonder de pagina te herladen; zonder dit
  // zou een net toegevoegd blok onzichtbaar blijven.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
